import { c as _c } from "react/compiler-runtime";
import { m } from 'framer-motion';
import Box from '@mui/material/Box';
import { varContainer } from './variants';

// ----------------------------------------------------------------------

export function MotionContainer(t0) {
  const $ = _c(18);
  let action;
  let animate;
  let children;
  let other;
  let sx;
  if ($[0] !== t0) {
    ({
      action,
      animate,
      children,
      sx,
      ...other
    } = t0);
    $[0] = t0;
    $[1] = action;
    $[2] = animate;
    $[3] = children;
    $[4] = other;
    $[5] = sx;
  } else {
    action = $[1];
    animate = $[2];
    children = $[3];
    other = $[4];
    sx = $[5];
  }
  let t1;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = varContainer();
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const t2 = action ? undefined : "exit";
  const t3 = action ? false : "initial";
  const t4 = action ? animate ? "animate" : "exit" : "animate";
  let t5;
  if ($[7] !== sx) {
    t5 = Array.isArray(sx) ? sx : [sx];
    $[7] = sx;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5) {
    t6 = [...t5];
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== children || $[12] !== other || $[13] !== t2 || $[14] !== t3 || $[15] !== t4 || $[16] !== t6) {
    t7 = <Box component={m.div} variants={t1} exit={t2} initial={t3} animate={t4} sx={t6} {...other}>{children}</Box>;
    $[11] = children;
    $[12] = other;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}